import { Ressource } from '@models/ressource';
import { content as depannageSiteWeb } from './articles/depannage-site-web';
import { content as angularZoneless } from './articles/angular-zoneless';
import { content as securiteNode } from './articles/securite-node';
import { content as architectureRgpd } from './articles/architecture-rgpd';
import { content as detteTechnique } from './articles/dette-technique';
import { content as signesAudit } from './articles/signes-audit';
import { content as monadesTypescript } from './articles/monades-typescript';
import { content as canaryDeployment } from './articles/canary-deployment';
import { content as ragMistral } from './articles/rag-mistral';
import { content as mlopsMistral } from './articles/mlops-mistral';
import { content as fineTuningSouverain } from './articles/fine-tuning-souverain';

export const ressources: Ressource[] = [
  {
    id: "fine-tuning-ia-souveraine-2026",
    type: "Guide Technique",
    titleAccent: "Fine-Tuning & Intégration IA Souveraine :",
    title: "Personnalisez votre IA en entreprise",
    date: "2026-01-30",
    author: "Olivier Girodin",
    role: "Expert Intégration IA @ Mesh Box",
    readTime: "12 min de lecture",
    excerpt: "Découvrez le fine-tuning IA souverain : transformez les LLM en spécialistes métier avec une souveraineté européenne totale. Techniques 2026, coûts, checklist pratique et conformité RGPD/AI Act.",
    image: "/assets/hero-architecture.jpg",
    content: fineTuningSouverain
  },
  {
    id: "mlops-mistral-fine-tuning-2026",
    type: "Guide Technique",
    titleAccent: "MLOps avec Mistral :",
    title: "Industrialisez Vos Modèles IA Après Fine-Tuning",
    date: "2026-01-26",
    author: "Olivier Girodin",
    role: "Expert Intégration IA @ Mesh Box",
    readTime: "15 min de lecture",
    excerpt: "Réussissez votre intégration IA avec le MLOps : industrialisez vos modèles Mistral post fine-tuning via pipelines automatisés, monitoring des drifts, et conformité AI Act pour une IA souveraine.",
    image: "/assets/hero-architecture.jpg",
    content: mlopsMistral
  },
  {
    id: "rag-mistral-ai-guide-2026",
    type: "Guide Technique",
    titleAccent: "Système RAG avec Mistral AI :",
    title: "Guide Complet d'Implémentation via LangChain",
    date: "2026-01-24",
    author: "Olivier Girodin",
    role: "Fondateur @ Mesh Box",
    readTime: "12 min de lecture",
    excerpt: "Implémentez un RAG 100% local et souverain avec LangChain : orchestration complète, embeddings open-source (bge-m3), Qdrant local et modèles Mistral open-weight via vLLM/Ollama.",
    image: "/assets/hero-architecture.jpg",
    content: ragMistral
  },
  {
    id: "canary-deployment-haproxy",
    type: "Architecture Technique",
    titleAccent: "Canary Deployment avec HAProxy :",
    title: "Tester un Nouveau Conteneur sans Tout Casser",
    date: "2026-01-21",
    author: "Olivier Girodin",
    role: "Expert DevOps @ Mesh Box",
    readTime: "10 min de lecture",
    excerpt: "Découvrez comment utiliser HAProxy pour un canary deployment, testant de nouvelles versions de vos conteneurs en production avec un risque minimal.",
    image: "/assets/hero-architecture.jpg",
    content: canaryDeployment
  },
  {
    id: "typescript-monades-design-patterns-2026",
    type: "Architecture Technique",
    titleAccent: "TypeScript :",
    title: "L'Illusion de Sécurité des Design Patterns (et le Piège du '!')",
    date: "2026-01-12",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "12 min de lecture",
    excerpt: "Découvrez pourquoi le 'Gang of Four' est obsolète en TypeScript moderne, pourquoi l'opérateur '!' est un mensonge, et comment les Monades sécurisent votre prod sans compromis.",
    image: "/assets/hero-architecture.jpg",
    content: monadesTypescript
  },
  {
    id: "depannage-site-web-node-2026",
    type: "Tech / Ingénierie",
    titleAccent: "Dépannage Site Web & API Node.js :",
    title: "Le Protocole de Récupération Critique",
    date: "2026-01-08",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "10 min de lecture",
    excerpt: "Votre application est hors ligne ? Voici le guide expert de dépannage spécialisé Node.js pour diagnostiquer les pannes silencieuses et remettre la production en ligne.",
    image: "/assets/icon-maintenance.svg",
    content: depannageSiteWeb
  },
  {
    id: "angular-zoneless-architecture-2026",
    type: "Architecture Technique",
    titleAccent: "Angular Zoneless :",
    title: "L'architecture 2026 haute performance",
    date: "2026-01-02",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "12 min de lecture",
    excerpt: "Découvrez pourquoi l'architecture Zoneless est le futur d'Angular. Analyse technique, comparatif de code et roadmap de migration pour les DSI.",
    image: "/assets/hero-architecture.jpg",
    content: angularZoneless
  },
  {
    id: "securite-node-janvier-2026",
    type: "Guide Technique",
    titleAccent: "Alerte Sécurité Node.js :",
    title: "Le Guide de Survie (Janvier 2026)",
    date: "2026-01-02",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "8 min de lecture",
    excerpt: "Analyse critique de la mise à jour Node.js du 7 janvier 2026. Découvrez la méthodologie Mesh Box pour auditer et sécuriser vos dépendances.",
    image: "/assets/case-modernization.jpg",
    content: securiteNode
  },
  {
    id: "architecture-rgpd-by-design",
    type: "Recommandation",
    titleAccent: "Architecture RGPD \"By Design\" :",
    title: "La Doctrine Mesh Box",
    date: "2025-12-31",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "10 min de lecture",
    excerpt: "Le RGPD comme pattern d'architecture. Logging sécurisé, Crypto-shredding, Chiffrement : la méthode Mesh Box pour une conformité 'Zero-Trust'.",
    image: "/assets/icon-audit.svg",
    content: architectureRgpd
  },
  {
    id: "fin-support-nodejs-18",
    type: "Guide Technique",
    titleAccent: "Dette Technique Node.js :",
    title: "ROI d'une Refonte en 2025",
    date: "2025-12-28",
    author: "Olivier Girodin",
    role: "Lead Architect @ Mesh Box",
    readTime: "15 min de lecture",
    excerpt: "Backend sous Node.js 18 ? Vous perdez de l'argent. Analyse financière et stratégie de modernisation par Olivier Girodin.",
    image: "/assets/case-modernization.jpg",
    content: detteTechnique
  },
  {
    id: "signes-audit-legacy",
    type: "Recommandation",
    titleAccent: "Code Legacy :",
    title: "3 signes qu'il est temps d'auditer",
    date: "2025-12-20",
    author: "Olivier Girodin",
    role: "CEO @ Mesh Box",
    readTime: "5 min de lecture",
    excerpt: "Votre application ralentit votre business ? Apprenez à identifier les signaux d’alerte avant que la dette technique ne devienne ingérable.",
    image: "/assets/case-platform.jpg",
    content: signesAudit
  }
];
